const baseDomain = 'https://telavox';
const readMoreUrls: Record<string, string> = {
    sv: `${baseDomain}.se/ai-receptionist/`,
    da: `${baseDomain}.dk/ai-receptionist/`,
    fi: `${baseDomain}.fi/ai-reseptionisti/`,
    nb: `${baseDomain}.no/ai-resepsjonist/`,
    fr: `${baseDomain}.fr/receptionniste-ia/`,
    'nl-NL': `${baseDomain}.be/ai-receptionist/`,
    'nl-BE': `${baseDomain}.be/ai-receptionist/`,
};

const defaultReadMoreUrl = 'https://telavox.co.uk/ai-receptionist/';

export const getReadMoreUrl = (language: string): string =>
    readMoreUrls?.[language] ?? defaultReadMoreUrl;
